export default __webpack_public_path__ + "static/media/chris.d8c287fe.png";